"use client"

import { Session } from "next-auth"
import { SessionProvider, useSession } from "next-auth/react"
import { createContext, ReactNode, useContext } from "react"

interface AuthContextType {
  session: Session | null
  status: "loading" | "authenticated" | "unauthenticated"
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}

const AuthContextProvider = ({ children }: { children: ReactNode }) => {
  const { data: session, status } = useSession()

  return (
    <AuthContext.Provider value={{ session, status }}>
      {children}
    </AuthContext.Provider>
  )
}

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  return (
    <SessionProvider>
      <AuthContextProvider>{children}</AuthContextProvider>
    </SessionProvider>
  )
}
